export default {
  easyLanguage: 'Lenguaje fácil',
  videoDoesNotYetExist: 'El video aún no existe'
}



// WEBPACK FOOTER //
// ./src/i18n/common/es.js